import { gql } from "@outschool/ui-apollo";

export const TopLevelCategoryPagesQuery = gql`
  query TopLevelCategoryPages($taxonomy: String) {
    topLevelCategoryPages(taxonomy: $taxonomy) {
      uid
      nameTitleCased
      nameSentenceCased
      slug
      title
      description
    }
  }
`;
